import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from 'lazy-route';

const dashboardRoutes = [
  <Route
    key="dashboard"
    exact
    path="/dashboard"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/user/pages/dashboard")}
      />
    )}
  />,
  <Route
    key="myprograms"
    exact
    path="/myprograms"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/MyPrograms")}
      />
    )}
  />,
  <Route
    key="packagelist"
    exact
    path="/packagelist"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/PackageList/index.js")}
      />
    )}
  />,
  <Route
    key="journey-module"
    exact
    path="/journey-module/:journey"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/MyJourneyModule")}
      />
    )}
  />,
  <Route
    key="profile"
    exact
    path="/profile"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/Profile/index")}
      />
    )}
  />,
  <Route
    key="myinvoices"
    exact
    path="/myinvoices"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/MyInvoices")}
      />
    )}
  />,
  <Route
    key="invoices"
    exact
    path="/invoices"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/Invoices")}
      />
    )}
  />,
  <Route
    key="invoices-single"
    exact
    path="/invoices/:iid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/InvoiceSingle")}
      />
    )}
  />,
  <Route
    key="module"
    exact
    path="/module"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/MyModule")}
      />
    )}
  />,
  <Route
    key="modules"
    exact
    path="/modules/:mid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/MyModules")}
      />
    )}
  />,
  <Route
    key="list-vouchers"
    exact
    path="/list_vouchers"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/Vouchers")}
      />
    )}
  />,
  <Route
    key="myvoucher"
    exact
    path="/myvoucher/:voucher_code/:pass"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/MyVoucher")}
      />
    )}
  />,
  <Route
    key="composite-calculator"
    exact
    path="/composite-calculator"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/user/pages/composite")}
      />
    )}
  />,
  <Route
    key="dashboard-media"
    exact
    path="/dashboard/media"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/user/pages/dashboard/MediaFiles")}
      />
    )}
  />,
  <Route
    key="dashboard-schedule"
    exact
    path="/dashboard/schedule"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/user/pages/dashboard/Schedule")}
      />
    )}
  />
];

export default dashboardRoutes; 